import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, Divider, Grid, Link, Paper, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useEffect, useState } from 'react';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const FreeFiling = () => {
  const [referralUrl, SetReferralUrl] = useState('freefiling');

  useEffect(() => {
    const isIRSPageReferral = document.referrer === 'https://www.irs.gov/';
    if (isIRSPageReferral) SetReferralUrl('freefilingirs');
  }, []);

  return (
    <AppLayout
      meta={
        <Meta
          titleTemplate="File IRS Forms Online Securely for Free"
          description="E-file eligible IRS forms online for free with TaxZerone. Fast, secure, and IRS-authorized e-filing platform built for simple and hassle-free tax filing."
          keywords=""
          canonical="free-filing/"
        />
      }
    >
      <Box component={'section'}
        sx={{
          '& .free-filing-bg:after': {
            height: {
              xs: 'calc(100% - 82%)',
              sm: 'calc(100% - 65%)',
              md: 'calc(100% - 60%)',
              lg: 'calc(100% - 55%)',
            },
          },
          '& .img-responsive-banner': { width: { xs: '90%', lg: '100%' } },
        }}
      >
        <Box
          sx={{
            backgroundColor: '#d2eedb',
            background:
              'url(/assets/images/free-filing-pattern-bg.webp) repeat-x center top #d2eedb',
            position: 'relative',
          }}
          className="free-filing-bg"
        >
          <Container maxWidth="md" sx={{ pt: 2, pb: 2 }}>
            <Box
              sx={{
                textAlign: { xs: 'center', md: 'center' },
                alignItems: 'center',
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
              }}
            >
              <Box
                component="header"
                sx={{
                  mt: { xs: 2, sm: 4, md: 5 },
                  mb: { xs: 0, sm: 0, md: 0 },
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                    fontWeight: 600,
                    color: '#374151',
                    mb: 3,
                  }}
                >
                  E-File IRS Forms with TaxZerone{' '}
                  {/* <span className="highlight-container">
                    <span className="highlight" style={{ color: '#213e99' }}>
                      FREE
                    </span>
                  </span>{' '}
                  with TaxZerone */}
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    color: '#374151',
                  }}
                >
                  <span className="highlight-container">
                    <span className="highlight" style={{ color: '#213e99' }}>
                      {' '}
                      Free
                    </span>
                  </span>{' '}
                  e-filing available for select IRS forms{' '}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    mb: 1,
                  }}
                  component="div"
                >
                  <Typography
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                      fontWeight: 400,
                    }}
                  >
                    File eligible IRS forms online for free with TaxZerone. Our
                    hassle-free e-filing platform makes tax filing easy and
                    efficient. As a trusted IRS-authorized e-file provider,
                    TaxZerone ensures a secure and reliable filing experience.
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'center',
                  }}
                  alignItems="center"
                  sx={{ mt: 4 }}
                >
                  <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 0 } }}>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      sx={{
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    >
                      Start Filing for&nbsp;
                      <Box
                        component="span"
                        sx={{ color: '#fffc00', fontWeight: 700 }}
                      >
                        FREE
                      </Box>
                      &nbsp;Today
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Container>
          <Container
            maxWidth="xl"
            sx={{ textAlign: { xs: 'left', md: 'center' } }}
          >
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: { lg: 24, md: 20, sm: 18, xs: 18 },
                fontWeight: 600,
                ml: { xs: 5.5, md: 0 },
              }}
            >
              Key Benefits:
            </Typography>
            <Box
              component="ul"
              sx={{
                '& li': { display: 'inline-flex', alignItems: 'center', mr: 2 },
              }}
            >
              <li>
                <CheckCircleIcon sx={{ color: '#1da94a', mr: 0.5 }} /> Free
                e-filing for select IRS forms
              </li>
              <li>
                <CheckCircleIcon sx={{ color: '#1da94a', mr: 0.5 }} />
                Trusted IRS-authorized provider
              </li>
              <li>
                <CheckCircleIcon sx={{ color: '#1da94a', mr: 0.5 }} />
                Secure and hassle-free filing process
              </li>
              <li>
                <CheckCircleIcon sx={{ color: '#1da94a', mr: 0.5 }} />
                Simple, user-friendly platform
              </li>
            </Box>
          </Container>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end',
              mt: '0 !important',
              position: 'relative',
              zIndex: 1,
              textAlign: 'center',
            }}
          >
            <picture style={{}}>
              <source srcSet="/assets/images/free-filing-landing-img.webp" />
              <source srcSet="/assets/images/free-filing-landing-img.png" />
              <img
                src="/assets/images/free-filing-landing-img.png"
                alt="E-file IRS Forms For FREE with TaxZerone"
                className="img-responsive-banner"
                width={1310}
                height={730}
              />
            </picture>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component={'section'}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Free E-Filing Available for Eligible Forms
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone offers free e-filing for certain required IRS forms,
                helping you manage your tax filings without unnecessary costs.
                Our platform is designed to simplify the filing process while
                keeping you compliant.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="lg" sx={{ mb: 5, px: { lg: '0 !important' } }}>
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            alignItems="center"
            sx={{ my: 5 }}
          >
            <Box
              sx={{
                width: '100%',
                minWidth: { md: 400, lg: 450 },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 26, md: 24, sm: 22, xs: 20 },
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Form 94x PIN Request
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 16, sm: 15, xs: 14 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 1,
                }}
              >
                Request your{' '}
                <Link
                  href="/employment-tax/e-file-irs-form-94x-pin-request/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  IRS Form 94x online signature PIN
                </Link>{' '}
                at{' '}
                <span style={{ fontWeight: 600 }}> no cost with TaxZerone</span>
                . Register online to securely obtain your PIN and confidently
                e-file your 94x forms, ensuring faster processing, secure
                submission, and full IRS compliance with an easy online process.
              </Typography>
              <Stack
                sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 4 }}
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent={{ xs: 'center', md: 'space-between' }}
              >
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    boxShadow: 'none',
                    textTransform: 'none',
                    borderRadius: 3,
                    background: '#0a7581',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  Request Your Form 94x PIN
                </Button>
              </Stack>
            </Box>{' '}
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/94x-free-img.webp" />
                <source srcSet="/assets/images/94x-free-img.png" />
                <img
                  src="/assets/images/94x-free-img.png"
                  alt="Form 94x PIN Request"
                  className="free-filing-img"
                  loading="lazy"
                  width={710}
                  height={510}
                />
              </picture>
            </Box>
          </Stack>
          <Divider sx={{}} />
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            alignItems="center"
            sx={{
              mb: 5,
              mt: 3,
              background: '#fff3dc',
              borderRadius: 3,
              py: 3,
              px: 5,
            }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/vin-free-img.webp" />
                <source srcSet="/assets/images/vin-free-img.png" />
                <img
                  src="/assets/images/vin-free-img.png"
                  alt="Form 2290 VIN Correction"
                  className="free-filing-img"
                  loading="lazy"
                  width={600}
                  height={498}
                  style={{ boxShadow: 'none', border: 'none', borderRadius: 0 }}
                />
              </picture>
            </Box>
            <Box
              sx={{
                width: '100%',
                minWidth: { md: 400, lg: 450 },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 26, md: 24, sm: 22, xs: 20 },
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Form 2290 VIN Correction
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 16, sm: 15, xs: 14 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 1,
                }}
              >
                Correct VIN errors on IRS Form 2290 quickly and at{' '}
                <span style={{ fontWeight: 600 }}> no cost</span>. Even if you
                originally filed elsewhere, TaxZerone makes{' '}
                <Link
                  href="/excise-tax/efile-irs-form-2290-vin-correction-online/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  Form 2290 VIN correction
                </Link>{' '}
                easy helping you fix VIN errors, avoid IRS delays, and stay
                compliant with a fast, hassle-free process.
              </Typography>
              <Stack
                sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 4 }}
                direction={{ xs: 'column', sm: 'row' }}
                alignItems="center"
                spacing={2}
                justifyContent={{ xs: 'center', md: 'space-between' }}
              >
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    boxShadow: 'none',
                    textTransform: 'none',
                    borderRadius: 3,
                    background: '#1da94a',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  File VIN Correction
                </Button>
              </Stack>
            </Box>{' '}
          </Stack>
          <Divider sx={{}} />
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            alignItems="center"
            sx={{ my: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/8868-free-img.webp" />
                <source srcSet="/assets/images/8868-free-img.png" />
                <img
                  src="/assets/images/8868-free-img.png"
                  alt="Free Form 8868 Extension for Exempt Organizations "
                  className="free-filing-img"
                  loading="lazy"
                  width={710}
                  height={510}
                />
              </picture>
            </Box>
            <Box
              sx={{
                width: '100%',
                minWidth: { md: 400, lg: 450 },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 26, md: 24, sm: 22, xs: 20 },
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Free Form 8868 Extension
                <br />
                for Exempt Organizations
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 16, sm: 15, xs: 14 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 1,
                }}
              >
                Get a{' '}
                <Link
                  href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  FREE Form 8868
                </Link>{' '}
                extension filing when you prepay your Form 990 Series with
                TaxZerone. E-file Form 8868 to extend your Form 990 deadline,
                stay IRS-compliant, and avoid penalties—no extra extension fees,
                just simple and secure filing
              </Typography>
              <Stack
                sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 4 }}
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent={{ xs: 'center', md: 'space-between' }}
              >
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    boxShadow: 'none',
                    textTransform: 'none',
                    borderRadius: 3,
                    background: '#213e99',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  E-File Form 8868
                </Button>
              </Stack>
            </Box>
          </Stack>
          <Divider sx={{}} />
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            alignItems="center"
            sx={{
              mb: 5,
              mt: 3,
              background: '#e8f4ff',
              borderRadius: 3,
              py: 3,
              px: 5,
            }}
          >
            <Box
              sx={{
                width: '100%',
                minWidth: { md: 400, lg: 450 },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 26, md: 24, sm: 22, xs: 20 },
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Request Form W-9 Online
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 16, sm: 15, xs: 14 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 1,
                }}
              >
                Easily request, manage, and store{' '}
                <Link
                  href="/request-form-w9-online-free/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  W-9 Forms online
                </Link>{' '}
                for <span style={{ fontWeight: 600 }}> FREE.</span> TaxZerone
                keeps your contractor and vendor W-9s organized, reduces errors,
                and ensures IRS compliance—fast and secure.
              </Typography>
              <Stack
                sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 4 }}
                direction={{ xs: 'column', sm: 'row' }}
                alignItems="center"
                spacing={2}
                justifyContent={{ xs: 'center', md: 'space-between' }}
              >
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    boxShadow: 'none',
                    textTransform: 'none',
                    borderRadius: 3,
                    // background: 'linear-gradient(#568dc7, #403994)',
                    background: '#4b42ad',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': {
                      transform: 'scale(1.1)',
                      background: '#172b6b',
                    },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  Request a W-9 Form Now!
                </Button>
              </Stack>
            </Box>{' '}
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/w9-free-img.webp" />
                <source srcSet="/assets/images/w9-free-img.png" />
                <img
                  src="/assets/images/w9-free-img.png"
                  alt="Request the W-9 Form Online for FREE"
                  className="free-filing-img"
                  loading="lazy"
                  width={600}
                  height={498}
                  style={{ boxShadow: 'none', border: 'none', borderRadius: 0 }}
                />
              </picture>
            </Box>
          </Stack>
          <Divider sx={{}} />
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            alignItems="center"
            sx={{ my: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/7004-free-img.webp" />
                <source srcSet="/assets/images/7004-free-img.png" />
                <img
                  src="/assets/images/7004-free-img.png"
                  alt="Free Form 7004 Extension for Business Tax Returns"
                  className="free-filing-img"
                  loading="lazy"
                  width={710}
                  height={510}
                />
              </picture>
            </Box>
            <Box
              sx={{
                width: '100%',
                minWidth: { md: 400, lg: 450 },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 26, md: 24, sm: 22, xs: 20 },
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Free Form 7004 Extension
                <br />
                for Business Tax Returns
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 16, sm: 15, xs: 14 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 1,
                }}
              >
                <Link
                  href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  E-file Form 7004 for free
                </Link>{' '}
                when you prepay your Form 1120-S or Form 1065 with TaxZerone and
                receive an automatic six-month extension to file your business
                tax return through a secure platform.
              </Typography>
              <Stack
                sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 4 }}
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent={{ xs: 'center', md: 'space-between' }}
              >
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    boxShadow: 'none',
                    textTransform: 'none',
                    borderRadius: 3,
                    background: '#213e99',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  E-File Form 7004
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f1f1f1',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component={'section'}
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 3,
              mt: 5,
              textAlign: 'center',
            }}
          >
            Benefits of E-filing IRS Forms with TaxZerone
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              color: '#333333',
              mb: 3,
              textAlign: 'center',
            }}
          >
            Discover why businesses choose TaxZerone to e-file their IRS forms.
          </Typography>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: { xs: 0, sm: 3 },
                  py: 1,
                  textAlign: 'left',
                  borderWidth: 0,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <picture style={{ width: 72, height: 72 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={72}
                      height={72}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={72}
                      height={72}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="Free E-Filing for Select Forms "
                      loading="lazy"
                      width={72}
                      height={72}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Free E-Filing for Select Forms
                </Typography>
                <Typography variant="body1">
                  TaxZerone offers free e-filing for certain required IRS forms,
                  helping you manage your tax filings without unnecessary costs.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: { xs: 0, sm: 3 },
                  py: 1,
                  textAlign: 'left',
                  borderWidth: 0,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <picture style={{ width: 72, height: 72 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={72}
                      height={72}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={72}
                      height={72}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized Provider "
                      loading="lazy"
                      width={72}
                      height={72}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  IRS-Authorized Provider
                </Typography>
                <Typography variant="body1">
                  As an IRS-authorized e-file provider, TaxZerone follows IRS
                  regulations to ensure accurate and compliant filings.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: { xs: 0, sm: 3 },
                  py: 1,
                  textAlign: 'left',
                  borderWidth: 0,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <picture style={{ width: 72, height: 72 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={72}
                      height={72}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={72}
                      height={72}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Intuitive Interface"
                      loading="lazy"
                      width={72}
                      height={72}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Intuitive Interface
                </Typography>
                <Typography variant="body1">
                  Our easy-to-use platform simplifies the e-filing process,
                  saving you time and making tax filing more manageable.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#393939',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: 0,
        }}
        component={'section'}
      >
        <Container sx={{ maxWidth: '1000px !important' }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                color="white"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Start Filing IRS Forms Today
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                  fontWeight: 400,
                  color: '#adadad',
                  lineHeight: 1.5,
                  mb: 3,
                }}
              >
                Take the first step toward stress-free tax filing with
                TaxZerone.
              </Typography>

              <Box component="div" sx={{ margin: 'auto', mt: 5 }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 0, sm: 0 },
                    mb: { xs: 0, md: 0 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &active': {
                      backgroundColor: '#1a7738 !important',
                      color: '#fff',
                      transform: 'scale(1.1)',
                    },
                  }}
                  className="btn-secondary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                >
                  Get Started Now
                </Button>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, mb: { xs: 0, md: 0 } }}
                  color="#aaa"
                >
                  Easy. Secure. IRS-authorized.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container maxWidth="lg" component={'section'} aria-labelledby="free-filing-faqs">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2" id="free-filing-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Is TaxZerone&apos;s e-filing service really free?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant='body1' itemProp="text">
                    Absolutely! TaxZerone offers a completely free e-filing
                    service for the specified IRS forms listed. There are no
                    hidden fees or charges involved.
                  </Typography>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Are there any limitations to the free e-filing service?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant='body1' itemProp="text">
                    While TaxZerone&apos;s e-filing service for the listed IRS
                    forms is entirely free, it&apos;s important to note that
                    this service may not cover all IRS forms. However, for the
                    forms mentioned, you can file them without spending any
                    money.
                  </Typography>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Can I e-file multiple forms with TaxZerone&apos;s free
                  service?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant='body1' itemProp="text">
                    Yes, you can e-file multiple forms listed without any
                    additional cost. TaxZerone is committed to providing a
                    seamless, cost-effective solution for your IRS form filing
                    needs.
                  </Typography>
                </Box>
              </Box>

              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can I file a VIN correction for FREE with TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant='body1' itemProp="text">
                    <b>Yes,</b> TaxZerone offers{' '}
                    <Link
                      href="/excise-tax/efile-irs-form-2290-vin-correction-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      VIN corrections
                    </Link>{' '}
                    <span style={{ fontWeight: 600 }}>completely FREE</span> of
                    charge. Our platform is designed to make the process of
                    correcting VIN errors easy and cost-effective for all Form
                    2290 filers.
                  </Typography>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Is there a fee to file Form 8868 with TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >

                  <Typography variant='body1' itemProp="text">
                    <b>No,</b> TaxZerone allows you to file{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 8868
                    </Link>{' '}
                    for FREE when you prepay for your applicable Form 990
                    e-filing. This cost-effective solution helps your
                    organization stay compliant without incurring additional
                    expenses.
                  </Typography>

                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Does TaxZerone provide a Form 94x PIN without any cost?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >

                  <Typography variant='body1' itemProp="text">
                    <b>Yes,</b> you can file a FREE{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      IRS Form 94x PIN
                    </Link>{' '}
                    request using TaxZerone! Simply register on our platform,
                    apply, and obtain a Form 94x PIN online, allowing you to
                    e-file your{' '}
                    <Link href="/employment-tax/" sx={{ color: '#0202ff' }}>
                      94x forms
                    </Link>{' '}
                    effortlessly.
                  </Typography>

                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  7. Can I request Form W-9 for FREE with TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >

                  <Typography variant='body1' itemProp="text">
                    <b>Yes,</b> TaxZerone allows you to request{' '}
                    <Link
                      href="/request-form-w9-online-free/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form W-9
                    </Link>{' '}
                    for <span style={{ fontWeight: 600 }}>FREE!</span> Our
                    platform provides a fast and efficient way to request,
                    manage, and store W-9 forms from your contractors and
                    vendors without any charges.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FreeFiling;
